import { z } from 'zod'

/**
 * Standard offset/limit pagination query shape for list endpoints.
 * Coerces stringy URL params into numbers and enforces bounds.
 *
 * Defaults: `offset: 0`, `limit: 10`. Callers can omit both params; parsed
 * request handlers receive concrete values.
 */
export const PaginationQuerySchema = z.object({
  offset: z.coerce.number().int().nonnegative().default(0),
  limit: z.coerce.number().int().positive().default(10),
})
